/**
 * Order Service
 * Handles order-related API calls
 */

import apiService from '../../../services/apiService';

const orderService = {
  // Create order
  async createOrder(orderData) {
    try {
      const response = await apiService.post('/shop/orders', orderData);
      return response;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  // Get user's orders
  async getOrders() {
    try {
      const response = await apiService.get('/shop/orders');
      return response;
    } catch (error) {
      console.error('Error fetching orders:', error);
      return [];
    }
  },

  // Get single order
  async getOrder(orderId) {
    try {
      const response = await apiService.get(`/shop/orders/${orderId}`);
      return response;
    } catch (error) {
      console.error('Error fetching order:', error);
      return null;
    }
  },

  // Download invoice
  async downloadInvoice(orderId) {
    try {
      const response = await apiService.get(`/shop/orders/${orderId}/invoice`, {
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice-${orderId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      return true;
    } catch (error) {
      console.error('Error downloading invoice:', error);
      return false;
    }
  }
};

export default orderService;

